(() => {
  const normalizeHeadingId = (text) => {
    const slug = text
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 72);

    return slug || 'section';
  };

  const createUniqueId = (heading, index) => {
    const requestedId = heading.id || normalizeHeadingId(heading.textContent || '');
    let uniqueId = requestedId;
    let suffix = 2;

    while (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading) {
      uniqueId = `${requestedId}-${suffix}`;
      suffix += 1;
    }

    return uniqueId || `section-${index + 1}`;
  };

  const buildTableOfContents = (root) => {
    const body = root.querySelector('[data-koota-article-body]');
    const toc = root.querySelector('[data-koota-toc]');
    const list = root.querySelector('[data-koota-toc-list]');

    if (!body || !toc || !list) return;

    const headings = [...body.querySelectorAll('h2')].filter((heading) => heading.textContent.trim());
    if (headings.length < 2) return;

    const links = headings.map((heading, index) => {
      heading.id = createUniqueId(heading, index);

      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      link.dataset.headingId = heading.id;
      list.appendChild(link);
      return link;
    });

    toc.hidden = false;

    if (!('IntersectionObserver' in window)) return;

    const visibleHeadings = new Map();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visibleHeadings.set(entry.target.id, entry.boundingClientRect.top);
          } else {
            visibleHeadings.delete(entry.target.id);
          }
        });

        let activeId = '';
        if (visibleHeadings.size) {
          activeId = [...visibleHeadings.entries()].sort((a, b) => a[1] - b[1])[0][0];
        } else {
          const passed = headings.filter((heading) => heading.getBoundingClientRect().top < 170);
          activeId = passed.length ? passed[passed.length - 1].id : headings[0].id;
        }

        links.forEach((link) => {
          const isActive = link.dataset.headingId === activeId;
          link.classList.toggle('is-active', isActive);
          if (isActive) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      },
      { rootMargin: '-120px 0px -68% 0px', threshold: 0 }
    );

    headings.forEach((heading) => observer.observe(heading));
  };

  const copyCurrentUrl = async (root) => {
    const button = root.querySelector('[data-koota-copy-link]');
    const status = root.querySelector('[data-koota-copy-status]');
    if (!button || !status) return;

    button.addEventListener('click', async () => {
      const defaultLabel = button.dataset.labelDefault || 'Copier le lien';
      const successLabel = button.dataset.labelSuccess || 'Lien copié';

      try {
        await navigator.clipboard.writeText(window.location.href);
        status.textContent = successLabel;
        button.setAttribute('aria-label', successLabel);
        window.setTimeout(() => {
          status.textContent = '';
          button.setAttribute('aria-label', defaultLabel);
        }, 2400);
      } catch (error) {
        status.textContent = window.location.href;
      }
    });
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-koota-article]').forEach((root) => {
      if (root.dataset.kootaInitialized === 'true') return;
      root.dataset.kootaInitialized = 'true';
      buildTableOfContents(root);
      copyCurrentUrl(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
